module.exports = __webpack_public_path__ + "img/undraw_adventure_4hum.5e8c36c2.svg";